<div [attr.data-automation]="dataAutomation()">
  @for (range of safeEntity; track fieldIds[$index]) {
    <ziro-time-range-form
      [entity]="range"
      [isFormSubmitted]="isFormSubmitted"
      [canDelete]="safeEntity.length > 1"
      [showDelete]="!hideDelete()"
      [isOverlapping]="isOverlappingAtIndex($index)"
      [timeIntervalMinutes]="15"
      (ziroFormsUpdate$)="onRangeUpdate($event, $index)"
      (deleteClicked)="deleteItem($index)"
    ></ziro-time-range-form>
  }
</div>
